export function prettyDate(uglyDate){
    let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    let formatDate = new Date(uglyDate);
    return formatDate.toLocaleDateString("en-US", options);
};




// WEBPACK FOOTER //
// ./src/_helpers/date.util.js